/**
 * Catálogos de proyecto homogéneos que el backend expone bajo
 * `/api/v1/catalogos-proyectos/*`. Los 4 comparten estructura CRUD
 * idéntica (controlador base `BaseCatalogoProyectoController`), así
 * que el frontend los maneja con un slice genérico parametrizado por
 * `slug`.
 */
export const CATALOGO_SLUGS = [
  'origenes',
  'naturalezas-financieras',
  'tipos-infraestructura',
  'tipos-servicio',
] as const;

export type CatalogoSlug = (typeof CATALOGO_SLUGS)[number];

export function isCatalogoSlug(value: unknown): value is CatalogoSlug {
  return typeof value === 'string' && (CATALOGO_SLUGS as ReadonlyArray<string>).includes(value);
}

type CatalogoMeta = {
  /** Etiqueta plural visible en sidebar y headers. */
  label: string;
  /** Etiqueta singular ("Nuevo {singular}"). */
  singular: string;
  /** Artículo gramatical para microcopy ("El origen", "La naturaleza"). */
  articulo: 'el' | 'la';
  /** Texto del placeholder de búsqueda. */
  searchPlaceholder: string;
  /** Texto vacío del listado sin filtros aplicados. */
  emptyLabel: string;
  /** Texto del CTA de creación en el header del listado. */
  nuevoLabel: string;
};

const META: Readonly<Record<CatalogoSlug, CatalogoMeta>> = {
  origenes: {
    label: 'Orígenes de proyecto',
    singular: 'origen',
    articulo: 'el',
    searchPlaceholder: 'Buscar por nombre del origen…',
    emptyLabel: 'Aún no hay orígenes registrados.',
    nuevoLabel: 'Nuevo origen de proyecto',
  },
  'naturalezas-financieras': {
    label: 'Naturalezas financieras',
    singular: 'naturaleza financiera',
    articulo: 'la',
    searchPlaceholder: 'Buscar por nombre de la naturaleza…',
    emptyLabel: 'Aún no hay naturalezas registradas.',
    nuevoLabel: 'Nueva naturaleza financiera',
  },
  'tipos-infraestructura': {
    label: 'Tipos de infraestructura',
    singular: 'tipo de infraestructura',
    articulo: 'el',
    searchPlaceholder: 'Buscar por nombre del tipo…',
    emptyLabel: 'Aún no hay tipos de infraestructura.',
    nuevoLabel: 'Nuevo tipo de infraestructura',
  },
  'tipos-servicio': {
    label: 'Tipos de servicio',
    singular: 'tipo de servicio',
    articulo: 'el',
    searchPlaceholder: 'Buscar por nombre del tipo…',
    emptyLabel: 'Aún no hay tipos de servicio.',
    nuevoLabel: 'Nuevo tipo de servicio',
  },
};

export function catalogoMeta(slug: CatalogoSlug): CatalogoMeta {
  return META[slug];
}
